export const splitBySeparators = (str: string, separators: string[]) => {
  const reg = new RegExp(`[${separators.join()}]`);
  return str.split(reg).filter((token) => token);
};
